import React, { useEffect } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { ForWhomSection } from '../components/ForWhomSection';
import { IncludesSection } from '../components/IncludesSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  // Simple fade-in effect on scroll
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('opacity-100', 'translate-y-0');
          entry.target.classList.remove('opacity-0', 'translate-y-10');
        }
      });
    }, {
      threshold: 0.1
    });
    document.querySelectorAll('section').forEach(section => {
      section.classList.add('transition-all', 'duration-1000', 'ease-out', 'opacity-0', 'translate-y-10');
      observer.observe(section);
    });
    return () => observer.disconnect();
  }, []);
  return <main className="min-h-screen w-full bg-[#F5F0E6] font-sans selection:bg-[#7C3AED] selection:text-white" data-id="element-205">
      <HeroSection data-id="element-206" />
      <ProblemSection data-id="element-207" />
      <MechanismSection data-id="element-208" />
      <ForWhomSection data-id="element-209" />
      <IncludesSection data-id="element-210" />
      <OfferSection data-id="element-211" />
      <Footer data-id="element-212" />
    </main>;
}